/**
 * Shared entity type metadata — icons, colors, labels.
 * Used by CommandPalette, EntityFilterPicker, SearchPage, etc.
 */
import {
  CheckSquare,
  Calendar,
  CalendarDays,
  User,
  Tag,
  Crosshair,
  LayoutGrid,
  Inbox,
  StickyNote,
  Paperclip,
  Scissors,
  type LucideIcon,
} from 'lucide-react';

export const ENTITY_ICONS: Record<string, LucideIcon> = {
  task: CheckSquare,
  meeting_instance: Calendar,
  meeting_series: CalendarDays,
  person: User,
  tag: Tag,
  scope: Crosshair,
  reference_doc: LayoutGrid,
  quick_capture: Inbox,
  note: StickyNote,
  attachment: Paperclip,
  excerpt: Scissors,
};

export const ENTITY_COLORS: Record<string, string> = {
  task: '#6366f1',
  meeting_instance: '#f59e0b',
  meeting_series: '#f59e0b',
  person: '#3b82f6',
  tag: '#a855f7',
  scope: '#ec4899',
  reference_doc: '#22c55e',
  quick_capture: '#64748b',
  note: '#14b8a6',
  attachment: '#94a3b8',
  excerpt: '#a3e635', // matches --color-excerpt
};

export const ENTITY_LABELS: Record<string, string> = {
  task: 'Task',
  meeting_instance: 'Meeting',
  meeting_series: 'Meeting Series',
  person: 'Person',
  tag: 'Tag',
  scope: 'Project',
  reference_doc: 'View',
  quick_capture: 'Capture',
  note: 'Note',
  attachment: 'File',
  excerpt: 'Excerpt',
};
